import React from "react";
import { observer } from "mobx-react";

import { Bet } from "@models";

export default observer(function CashoutIndicator(props: { bet: Bet }) {
	if (props.bet.indicator === 1) {
		return (
			<i className="u-icon u-icon--tny u-icon--caret--up u-color--sent--success" />
		);
	}

	if (props.bet.indicator === -1) {
		return (
			<i className="u-icon u-icon--tny u-icon--caret--down u-color--sent--danger" />
		);
	}
	return null;
});
